import { logUsage } from 'owa-analytics';
import type { FluidLoadSource, FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';
import {
    convertFluidLoadOwaScenarioToString,
    convertFluidLoadSourceToString,
    convertFluidOwaSourceToString,
} from '../utils/convertEnumToString';

export default function fluidComponentError(
    owaScenario: FluidLoadOwaScenario,
    owaSource: FluidOwaSource,
    source: FluidLoadSource,
    error: Error
) {
    const errorString = error
        ? typeof error === 'string'
            ? JSON.stringify({ message: error })
            : JSON.stringify(error, Object.getOwnPropertyNames(error))
        : error + '';

    const scenarioString: string = convertFluidLoadOwaScenarioToString(owaScenario);
    const owaSourceString: string = convertFluidOwaSourceToString(owaSource);
    const sourceString: string = convertFluidLoadSourceToString(source);
    logUsage(
        'FluidComponentError',
        {
            OwaScenario_1: scenarioString,
            ComponentSource_2: sourceString,
            Error_3: errorString,
            OwaSource_4: owaSourceString,
        },
        { isCore: true }
    );
}
